module.exports = "/_next/static/images/StudyJam-0435464c10d918a233f74bf99ccc771f.jpg";